const main = {
    margin: '0',
    display: 'grid',
    padding: '0.25rem 0 0',
    minHeight: '90vh',
};
const gridContainer = (isMobile) => ({
    margin: isMobile ? '0px' : '2rem 1.5rem 0 1.5rem',
    display: 'grid',
    gap: '2.5rem',
    gridTemplateColumns: 'repeat(auto-fill, minmax(370px, 1fr)',
});
const cardContainer = {
    padding: '0!important',
};
const cardHeader = {
    width: '100%',
    display: 'flex',
    padding: {
        desktop: '40px 80px',
        mobile: '24px',
    },
};
const cardSubtitle = {
    display: 'flex',
    flexGrow: 1,
    paddingX: {
        mobile: '24px',
        desktop: '80px',
    },
    gap: '16px',
};
const bottom = {
    display: 'flex',
    flexDirection: {
        desktop: 'row',
        mobile: 'column',
    },
    justifyContent: 'space-between',
    width: '100%',
    '& .MuiButton-root': {
        width: {
            desktop: '192px',
            mobile: '100%',
        },
    },
    '& .MuiTypography-root': {
        alignSelf: 'flex-end',
        margin: {
            desktop: '1rem 0',
            mobile: '1rem 0',
        },
    },
};
const emptyCard = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    justifyContent: 'center',
    height: '100%',
    paddingLeft: '48px',
    paddingRight: '48px',
    textAlign: 'center',
    '& .MuiButton-root': {
        alignSelf: 'center',
        width: {
            desktop: '180px',
            mobile: '100%',
        },
    },
};
const merchantCardWrapper = {
    display: 'flex',
    flexWrap: 'wrap',
    flex: '1 0 33%',
    gap: {
        mobile: '16px',
        desktop: '24px',
    },
    flexDirection: 'row',
    padding: {
        mobile: '24px',
        desktop: '8px 56px 40px',
    },
    '> div': {
        minWidth: '100%', //This might interfere with the InfiniteScroll component functionality. If it does, remove it.
    },
    '& > .MuiTypography-root': {
        marginLeft: {
            mobile: '0',
            desktop: '42px',
        },
    },
};
const errorContainer = {
    minHeight: '600px',
    width: { mobile: '100%', desktop: '50%' },
    padding: {
        desktop: '40px 80px',
        mobile: '24px',
    },
};
export default {
    main,
    cardHeader,
    cardContainer,
    gridContainer,
    cardSubtitle,
    bottom,
    emptyCard,
    merchantCardWrapper,
    errorContainer,
};
